import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import PrimaryTheme from "../Themes/Primary";
import { useSelector, useDispatch } from "react-redux";
import { Reducers } from "../Interfaces/Interfaces";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertModal(props: DialogProps) {
  const modalAlert = useSelector((state: Reducers) => state.modalAlert);
  const dispatch = useDispatch();

  const handleClose = () => {
    // if ( "backdropClick")
    //   return;
    dispatch({
      type: "ALERT_MODAL",
      payload: false,
    });
  };

  return (
    <div
      className="position-relative"
      style={{
        borderRadius: "20px !important",
      }}
    >
      <Dialog
        open={modalAlert}
        TransitionComponent={Transition}
        keepMounted
        scroll="body"
        fullWidth
        maxWidth={props.maxWidth}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="position-relative">
          {props.showClose && (
            <React.Fragment>
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: props.blueCloseBtn ? "12px 12px 0 32px" : "32px",
                }}
              >
                <div
                  // className="p-4"
                  style={{
                    color: "#000",
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "22.4px",
                    fontFamily: '"SF UI Display"',
                    // padding: "0.8rem 0.8rem 0.8rem 32px",
                  }}
                >
                  {props.title}
                </div>
                {props.blueCloseBtn ? (
                  // blue close button
                  <div
                    onClick={handleClose}
                    style={{
                      background: "#F3F7FF",
                      borderRadius: "56px",
                      padding: "8px",
                      marginRight: "12px",
                      cursor: "pointer",
                    }}
                    className="d-flex"
                  >
                    <img src="/x-frame.svg" />
                  </div>
                ) : (
                  <div
                    onClick={handleClose}
                    style={{
                      width: 50,
                      height: 50,
                      position: "absolute",
                      top: 0,
                      right: 0,
                      backgroundColor: PrimaryTheme.warn,
                      color: PrimaryTheme.black,
                      fontSize: PrimaryTheme.fontSizes?.subtitle,
                      borderBottomLeftRadius: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      className="bi bi-x"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}

          {props.children}
        </div>
      </Dialog>
    </div>
  );
}

interface DialogProps {
  children?: React.ReactElement;
  open?: boolean;
  showClose?: boolean;
  maxWidth?: "sm" | "lg" | "md" | "xs" | "xl";
  title?: string;
  blueCloseBtn?: boolean;
}
